import React from 'react';
import EmptyImage from '../../../../components/emptyImage';
import ProductPrice from '../../../../components/productPrice';
import { generateVariantTitle } from '../../../../utils/draftOrder';

import './product-item.scss';

const ProductItem = ({ product }) => {
      return (
            <div className='selected-product-variant-container'>
                  <div className='selected-product-variant-item'>
                        <div className='selected-product-variant-item-description'>
                              {product.image ? (
                                    <img
                                          className='main-image'
                                          src={product.image}
                                    />
                              ) : (
                                    <EmptyImage product={product} size={'xs'} />
                              )}

                              <div className='product-description'>
                                    <span className='product-title'>{product.productTitle}</span>
                                    <span className='variant-title'>{generateVariantTitle(product.title || product.variantTitle)}</span>
                                    <div className={'price-container'}>
                                          <ProductPrice
                                                selectedProductVariant={product}
                                          />
                                    </div>
                              </div>
                        </div>
                        <div className='selected-product-variant-actions'>
                            <span className='quantity-input'>
                              <input
                                    type='number'
                                    value={product.quantity}
                                    readOnly
                              />
                            </span>
                        </div>
                  </div>
            </div>
      )
}

export default ProductItem;
